import { useQueryClient } from '@tanstack/react-query';

import {
	MIDDLEWARE_SMO,
	MIDDLEWARE_SMO_STATUSES,
	NETWORK_ELEMENTS,
	NETWORK_ELEMENTS_CONNECTION_LOGS,
} from '@constants/queryKeys';

const useInvalidateMiddlewareSMO = () => {
	const queryClient = useQueryClient();

	const invalidateMiddlewareSMO = () => {
		return [
			queryClient.invalidateQueries([NETWORK_ELEMENTS]),
			queryClient.invalidateQueries([NETWORK_ELEMENTS_CONNECTION_LOGS]),
			queryClient.invalidateQueries([MIDDLEWARE_SMO]),
			queryClient.invalidateQueries([MIDDLEWARE_SMO_STATUSES]),
		];
	};

	return invalidateMiddlewareSMO;
};

export default useInvalidateMiddlewareSMO;
